import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { InstitutionItemStyle } from './InstitutionItemStyle';

import { institutionShape } from '../../utils/propTypesShapes';
import EditIcon from '../../assets/svgs/EditIcon';
import DeleteIcon from '../../assets/svgs/DeleteReportIcon';

import AdministratorIcon from '../../assets/svgs/AdministratorIcon';
import RegisterPeopleIcon from '../../assets/svgs/RegisterPeopleIcon';
import ListExamIcon from '../../assets/svgs/ListExamIcon';
import OptionsIcon from '../../assets/svgs/OptionsIcon';

const useClickOutside = (handler) => {
  const elemento = useRef();

  useEffect(() => {
    const closeOptionsList = (event) => {
      if (!elemento?.current?.contains(event?.target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', closeOptionsList);

    return () => {
      document.addEventListener('mousedown', closeOptionsList);
    };
  });

  return elemento;
};

const InstitutionItem = ({
  institutionItem,
  galleryMode,
  handleDeleteUnit,
  handleOpenEditInstitutionForm,
}) => {
  const [optionsGallery, setOptionsGallery] = useState(false);

  const elemento = useClickOutside(() => {
    setOptionsGallery('');
  });

  return (
    <InstitutionItemStyle className={galleryMode}>
      <div className={`institution-list-item${galleryMode}`}>
        {galleryMode ? (
          <button
            type="button"
            className="options-icon"
            onClick={() => setOptionsGallery(!optionsGallery)}
          >
            <OptionsIcon />
          </button>
        ) : null}
        {optionsGallery && galleryMode ? (
          <div
            id="list-options-gallery"
            className="options-gallery"
            ref={elemento}
          >
            <button
              type="button"
              className="option"
              onClick={() => handleOpenEditInstitutionForm(institutionItem.id)}
            >
              <div className="icon-container">
                <EditIcon />
              </div>
              <span>Edit Institution Information</span>
            </button>
            <button
              type="button"
              className="option"
              onClick={() => handleDeleteUnit(institutionItem.id)}
            >
              <div className="icon-container">
                {' '}
                <DeleteIcon />
              </div>
              <span>Delete Institution</span>
            </button>
          </div>
        ) : null}
        <div className={`logo-container${galleryMode}`}>
          {institutionItem?.image ? (
            <div className={`institution-photo${galleryMode}`}>
              <img
                src={institutionItem.image}
                className={`logo-image${galleryMode}`}
                alt="institution logo"
              />
            </div>
          ) : (
            <div className={`logo-placeholder${galleryMode}`}>
              <span className="logo-placeholder-content">CD</span>
            </div>
          )}
          {galleryMode ? (
            <div
              className={`institution-name-item institution-item-data${galleryMode}`}
            >
              <span>{institutionItem?.name ? institutionItem.name : null}</span>
            </div>
          ) : null}
        </div>
        <div className={`institution-information${galleryMode}`}>
          <div
            className={`institution-name-item institution-item-data${galleryMode}`}
          >
            <span>{institutionItem?.name ? institutionItem.name : null}</span>
          </div>
          <div
            className={`registration-item institution-item-data${galleryMode}`}
          >
            {galleryMode ? (
              <div className="icon-container">
                <RegisterPeopleIcon />
              </div>
            ) : null}
            <span>
              {institutionItem?.registrations || 0}
              {galleryMode ? ' registrations' : null}
            </span>
          </div>
          <div className={`exams-item exams-item-data${galleryMode}`}>
            {galleryMode ? (
              <div className="icon-container">
                <ListExamIcon />
              </div>
            ) : null}
            <span>
              {institutionItem?.exams?.this_month
                ? institutionItem?.exams?.this_month
                : 0}
              {galleryMode ? ' exams this month' : null}
            </span>
          </div>
          <div
            className={`administrator-list-item administrator-item-data${galleryMode}`}
          >
            {galleryMode ? (
              <div className="icon-container">
                <AdministratorIcon />
              </div>
            ) : null}
            <span>{institutionItem?.admin_name || '-'}</span>
          </div>
          <div
            className={`actions-list-item user-list-item-data${galleryMode}`}
          >
            <div className="actions-item">
              <button
                type="button"
                className="edit-button"
                onClick={() =>
                  handleOpenEditInstitutionForm(institutionItem.id)
                }
              >
                <EditIcon />{' '}
              </button>
              <button
                type="button"
                onClick={() => handleDeleteUnit(institutionItem.id)}
              >
                <DeleteIcon />
              </button>
            </div>
          </div>
          {galleryMode ? null : <div className="go-to-user-text">see more</div>}
        </div>
      </div>
    </InstitutionItemStyle>
  );
};

InstitutionItem.propTypes = {
  institutionItem: institutionShape,
  galleryMode: PropTypes.string,
  handleDeleteUnit: PropTypes.func.isRequired,
  handleOpenEditInstitutionForm: PropTypes.func.isRequired,
};

InstitutionItem.defaultProps = {
  institutionItem: {},
  galleryMode: '',
};

export default InstitutionItem;
